import { createGlobalRoute } from '@townsquare/router/create-route';
import type { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const starredRouteDefinition: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: 'starred',
	path: '/starred',
	layout: 'home',
});
